import { ImageCover, TeamActionTypes } from '../store';

import { SelectValue } from '@/types';
import { TarjetaTokenizada } from '@/types/myAccount';

export const TEXTS = {
  // === ERRORS ===
  defaultError:
    'Lo sentimos, sucedió un error inesperado, intentá de nuevo mas tarde.',
  exclusiveForArgentinianDTs:
    'La participación en esta competencia es exclusiva para DTs argentinos.',
  callCenterError:
    'Comuníquese con nuestro centro de atención al 0800-333-2343.',
  notFoundSchools:
    "No existe en nuestra base ninguna escuela para la localidad/barrio seleccionado. Si igualmente querés participar de Gran DT, hacé click en el botón 'No quiero participar'.",
  // veda: 'Se está jugando la fecha. No podés realizar modificaciones en tu equipo.',
  // gdtHasEnded: 'Gran DT ha finalizado.',
  userExists:
    'Ya existe un usuario registrado con el tipo y número de documento ingresado. Modificá el documento o volvé a iniciar sesión.',
  noResults: 'No se encontraron resultados.',
  playerNotFound: 'No se encontraron jugadores con los filtros actuales.',
  notFoundResult:
    'No se encontraron resultados para tu búsqueda actual. Intentalo de nuevo.',
  auth0Error: 'Error al obtener la configuración de Auth0.',
  initialDataError: 'Error al obtener información inicial.',
  nameTeamInvalid:
    'Ya existe un equipo con ese nombre. Modificalo y comenzá a jugar.',
  errorRequestValidationName:
    'Error al obtener el servicio de validacion de nombre de equipo.',
  dontHavePermits: 'No tenés permisos para ingresar a esta sección.',
  getTeam: 'Error al obtener tu equipo.',
  saveTeam: 'Error al guardar tu equipo.',
  getTeamData: 'Error al obtener los datos de tu equipo',
  initSpaceOnInputField: 'El nombre no puede comenzar con espacios',
  minLetters: 'Ingresá al menos dos caracteres.',
  // === END ERRORS ===
  myCbu: {
    nameAndSurName:
      'El titular de la cuenta debe tener de 5 a 50 caracteres y no puede contener números ni caracteres especiales.',
    cuit: 'El Cuit debe tener de 2 a 11 caracteres.',
    bank: 'El Banco debe tener de 2 a 50 caracteres y no puede contener números ni caracteres especiales.',
    acountNumber: 'El numero de cuenta debe tener de 2 a 50 caracteres.',
    cbu: 'El CBU debe tener 22 dígitos y ser válido',
  },
  team: {
    noVacant: 'No hay vacante para la posición de este jugador.',
    playerAlreadyExists:
      'Este jugador ya forma parte de tu equipo. Por favor, elegí otro.',
    noPlayerPosition:
      'La posicion seleccionada en cancha no corresponde a la posición del jugador seleccionado.',
    playerAddedOnTeamDraft: 'ahora forma parte de tu equipo',
    pickCaptain:
      'Para confirmar tu equipo es necesario que elijas a tu Capitán',
    pickCaptainAndInsuranced: [
      '¡Tu equipo está completo! Ahora elegí',
      'un Capitán',
      'a tu Jugador Asegurado',
    ],
    captainPicked:
      '¡Elegiste tu Capitán! Duplicará la calificación de Clarín en cada fecha.',
    maxHeadlinesAllow:
      'Superaste el límite de futbolistas titulares para esta posición. Revisá tu selección.',
    maxSubstitutesAllow:
      'Ya tenés un suplente elegido para esta posición. No es posible sumar otro.',
    insurancedPickedF5:
      '¡Elegiste tu asegurado! Sumará 5 puntos en caso de que no juegue.',
  },
  personalDataUpdated:
    'Tus datos personales han sido actualizados correctamente.',
  minTwoNumbers: 'Ingresá al menos dos números.',
  minTransferAmount: 'Minimo permitido 2 caracteres.',
  editPersonalData: {
    areaCode: 'El codigo de Area no puede ser mayor a 4 digitos',
    phoneNumber: 'El numero de celular no puede ser mayor a 9 digitos',
  },
  registration: {
    name: 'El nombre debe tener de 2 a 30 caracteres y no puede contener números ni caracteres especiales.',
    lastName:
      'El apellido debe tener de 2 a 30 caracteres y no puede contener números ni caracteres especiales.',
    docNumber: 'Mínimo permitido 2 caracteres.',
  },
  docNumberValid: 'Ingresá un número válido.',
  clubName: {
    length: 'El nombre de club debe tener entre 2 a 30 caracteres.',
  },
  emailValid: 'Ingresá un email válido',
  nameTeam: 'El nombre debe tener entre 2 y 30 caracteres.',
  prevTeam: {
    success:
      'Jugadores agregados. Se incorporaron solo aquellos que participan actualmente del Campeonato de Primera División.',
    noBudge:
      'No se sumaron todos tus jugadores de la edición pasada ya que el equipo superaba el presupuesto permitido.',
  },
  transfer: {
    tacticError:
      'No se puede realizar esta transferencia. La formación no se ajusta a ninguna de las 9 tácticas disponibles.',
  },
  pins: {
    invalid:
      'El pin no puede contener caracteres especiales. Se aceptan sólo números y letras.',
    maxlenght: 'El pin no puede contener mas de 12 caracteres.',
    savedSuccessfully: 'El pin fue cargado exitosamente a tu cuenta.',
    errorGetInit: 'Error al obtener los datos de tu cuenta',
  },
  noBudget: 'El presupuesto del equipo no puede superar los $65.000.000.',
  sameTeamLimit: 'Ya han sido incorporados 4 jugadores del mismo club',
  minTwoCharacters: 'Ingresá al menos dos caracteres.',
  miniumAllowed2Characters: 'Mínimo permitido 2 caracteres.',
  tda: {
    minName:
      'El nombre del Torneo de Amigos debe contener al menos 2 caracteres',
    maxName:
      'El nombre del Torneo de Amigos no puede contener mas de 25 caracteres',
    invalidCharacter:
      'El nombre del Torneo de Amigos no puede contener caracteres especiales.',
    invalidCharacterDT: 'El nombre no puede contener caracteres especiales.',
  },
  fCup: {
    minName: 'El nombre del equipo debe contener al menos 2 caracteres',
    maxName: 'El nombre del equipo no puede contener mas de 25 caracteres',
    invalidCharacter:
      'El nombre del equipo no puede contener caracteres especiales.',
  },
  minileague: {
    minName: 'El nombre de la Miniliga debe contener al menos 2 caracteres',
    maxName: 'El nombre de la Miniliga no puede contener más de 25 caracteres',
    invalidCharacter:
      'El nombre de la Miniliga no puede contener caracteres especiales.',
    invalidCharacterDT: 'El nombre no puede contener caracteres especiales.',
  },
  search: {
    invalidCharacter:
      'El término de búsqueda no puede contener caracteres especiales.',
  },
  nameExist: 'Este nombre ya existe. Por favor, elegí otro.',
};

export const DOC_TYPES: SelectValue[] = [
  { label: 'DNI', value: 1 },
  { label: 'LC', value: 2 },
  { label: 'LE', value: 3 },
];

export const FAQ_SUBCAT: SelectValue[] = [
  { label: 'REG1', value: 1 },
  { label: 'REG2', value: 2 },
  { label: 'REG3', value: 3 },
  { label: 'REG4', value: 4 },
  { label: 'REG5', value: 5 },
  { label: 'REG6', value: 6 },
  { label: 'REG7', value: 7 },
];

export const OPTIONS_POSITIONS: SelectValue[] = [
  { label: 'Todas las posiciones', value: 0 },
  { label: 'Arquero', value: 1 },
  { label: 'Defensor', value: 2 },
  { label: 'Volante', value: 3 },
  { label: 'Delantero', value: 4 },
];

export const focusClass =
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-gdt-blue-light';

export const inputTextBaseClass = `placeholder:text-gdt-gray-4 block w-full px-[16px] py-[12px] rounded-[8px] border border-gdt-gray-5 text-sm text-gdt-gray-2 focus:ring-0 font-medium ${focusClass}`;

export const MAX_INPUT_RANGE = 10000000;
export const MIN_INPUT_RANGE = 300000;

export const ORDER_FILTER_LIST: SelectValue[] = [
  {
    label: 'Elegir orden',
    value: -1,
  },
  {
    label: 'Cotización más alta',
    value: 6,
  },
  {
    label: 'Cotización más baja',
    value: 7,
  },
  {
    label: 'Orden alfabético',
    value: 1,
  },
  {
    label: 'En más equipos Gran DT',
    value: 2,
  },
  {
    label: 'En menos equipos Gran DT',
    value: 3,
  },
  {
    label: 'Mayor puntaje',
    value: 4,
  },
  {
    label: 'Menor puntaje',
    value: 5,
  },
];

export type TeamListItem = {
  value: number;
  label: string;
  colors?: {
    primary: string;
    secondary: string;
  };
};

export const RAW_TEAM_LIST: TeamListItem[] = [
  {
    value: 106,
    label: '9 de Julio (Rafaela)',
  },
  {
    value: 40,
    label: 'Acassuso',
  },
  {
    value: 20,
    label: 'Aldosivi',
    colors: {
      primary: '#398F7B',
      secondary: '#FFF500',
    },
  },
  {
    value: 21,
    label: 'All Boys',
  },
  {
    value: 22,
    label: 'Almagro',
  },
  {
    value: 41,
    label: 'Alte. Brown',
  },
  {
    value: 103,
    label: 'Alvarado (Mar del Plata)',
  },
  {
    value: 60,
    label: 'Argentino de Merlo',
  },
  {
    value: 80,
    label: 'Argentino de Quilmes',
  },
  {
    value: 61,
    label: 'Argentino de Rosario',
  },
  {
    value: 17,
    label: 'Argentinos',
    colors: {
      primary: '#DE2F28',
      secondary: '#FFFFFF',
    },
  },
  {
    value: 4,
    label: 'Arsenal',
    colors: {
      primary: '#F6060F',
      secondary: '#00C3FB',
    },
  },
  {
    value: 24,
    label: 'Atl. Tucumán',
    colors: {
      primary: '#62BCF1',
      secondary: '#FAFDFA',
    },
  },
  {
    value: 42,
    label: 'Atlanta',
  },
  {
    value: 81,
    label: 'Atlas',
  },
  {
    value: 11,
    label: 'Banfield',
    colors: {
      primary: '#008B2E',
      secondary: '#FAFDFA',
    },
  },
  // {
  //   value: 77,
  //   label: 'Barracas Bolívar',
  // },
  {
    value: 62,
    label: 'Barracas Central',
    colors: {
      primary: '#EB080E',
      secondary: '#FEFEFE',
    },
  },
  {
    value: 25,
    label: 'Belgrano',
    colors: {
      primary: '#2F9CD7',
      secondary: '#DAE9F6',
    },
  },
  {
    value: 107,
    label: 'Ben Hur (Rafaela)',
  },
  {
    value: 63,
    label: 'Berazategui',
  },
  {
    value: 19,
    label: 'Boca',
    colors: {
      primary: '#0137C7',
      secondary: '#F9DA0C',
    },
  },
  {
    value: 43,
    label: 'Brown de Adrogué',
  },
  {
    value: 26,
    label: 'CAI de Comodoro Rivadavia',
  },
  {
    value: 64,
    label: 'Cambaceres',
  },
  {
    value: 65,
    label: 'Cañuelas',
  },
  {
    value: 83,
    label: 'Central Ballester',
  },
  {
    value: 118,
    label: 'Central Córdoba (Santiago del Estero)',
    colors: {
      primary: '#000000',
      secondary: '#FFFFFF',
    },
  },
  {
    value: 44,
    label: 'Central Córdoba',
    colors: {
      primary: '#000000',
      secondary: '#FFFFFF',
    },
  },
  {
    value: 643,
    label: 'Estudiantes RC',
    colors: {
      primary: '#2F9CD7',
      secondary: '#DAE9F6',
    },
  },
  {
    value: 116,
    label: 'Gimnasia Mza',
    colors: {
      primary: '#000000',
      secondary: '#FFFFFF',
    },
  },
  {
    value: 84,
    label: 'Centro Español',
  },
  {
    value: 27,
    label: 'Chacarita',
    colors: {
      primary: '#EC1B23',
      secondary: '#350000',
    },
  },
  {
    value: 642,
    label: 'Chaco For Ever',
  },
  {
    value: 99,
    label: 'Cipoletti (Rio Negro)',
  },
  {
    value: 85,
    label: 'Claypole',
  },
  {
    value: 566,
    label: 'Colegiales',
  },
  {
    value: 7,
    label: 'Colón',
    colors: {
      primary: '#000000',
      secondary: '#D30012',
    },
  },
  {
    value: 45,
    label: 'Comunicaciones',
  },
  {
    value: 565,
    label: 'Crucero del N.',
  },
  {
    value: 28,
    label: 'Def. y Justicia',
    colors: {
      primary: '#FFDD00',
      secondary: '#00722D',
    },
  },
  {
    value: 46,
    label: 'Defensores de Belgrano',
  },
  {
    value: 66,
    label: 'Defensores Unidos',
  },
  {
    value: 49,
    label: 'Dep. Merlo',
  },
  {
    value: 47,
    label: 'Deportivo Armenio',
  },
  {
    value: 48,
    label: 'Deportivo Español',
  },
  {
    value: 67,
    label: 'Deportivo Laferrere',
  },
  {
    value: 117,
    label: 'Deportivo Maipú (Mendoza)',
  },
  {
    value: 567,
    label: 'Deportivo Mandiyú',
  },
  {
    value: 50,
    label: 'Deportivo Morón',
  },
  {
    value: 86,
    label: 'Deportivo Paraguayo',
  },
  {
    value: 87,
    label: 'Deportivo Riestra',
    colors: {
      primary: '#262526',
      secondary: '#FFFFFF',
    },
  },
  {
    value: 563,
    label: 'Desamparados',
  },
  {
    value: 95,
    label: 'Dock Sud',
  },
  {
    value: 564,
    label: 'Douglas Haig',
  },
  {
    value: 68,
    label: 'El Porvenir',
  },
  {
    value: 51,
    label: 'Estudiantes de Buenos Aires',
    colors: {
      primary: '#EC1B23',
      secondary: '#FEFDFD',
    },
  },
  {
    value: 10,
    label: 'Estudiantes',
    colors: {
      primary: '#FEFDFD',
      secondary: '#EC1B23',
    },
  },
  {
    value: 69,
    label: 'Excursionistas',
  },
  {
    value: 70,
    label: 'Fénix',
  },
  {
    value: 29,
    label: 'Ferro',
  },
  {
    value: 89,
    label: 'Ferrocarril Urquiza',
  },
  {
    value: 52,
    label: 'Flandria',
  },
  {
    value: 98,
    label: 'G. Brown',
  },
  {
    value: 71,
    label: 'General Lamadrid',
  },
  {
    value: 111,
    label: 'Gimnasia (Concepción del Uruguay)',
  },
  {
    value: 13,
    label: 'Gimnasia J.',
  },
  {
    value: 1,
    label: 'Gimnasia L.P.',
    colors: {
      primary: '#121A61',
      secondary: '#FFFFFF',
    },
  },
  {
    value: 9,
    label: 'Godoy Cruz',
    colors: {
      primary: '#0052F2',
      secondary: '#FAFBFD',
    },
  },
  {
    value: 5,
    label: 'Huracán',
    colors: {
      primary: '#FFFFFF',
      secondary: '#FF696A',
    },
  },
  {
    value: 3,
    label: 'Independiente',
    colors: {
      primary: '#FE0000',
      secondary: '#FFACAC',
    },
  },
  {
    value: 30,
    label: 'Ind. Rivadavia',
    colors: {
      primary: '#2a1972',
      secondary: '#FFFFFF',
    },
  },
  {
    value: 31,
    label: 'Instituto',
    colors: {
      primary: '#FFFFFF',
      secondary: '#EC1B23',
    },
  },
  {
    value: 90,
    label: 'Ituzaingó',
  },
  {
    value: 72,
    label: 'J.J. Urquiza',
  },
  {
    value: 104,
    label: 'Juventud (Pergamino)',
  },
  {
    value: 115,
    label: 'Juventud Antoniana',
  },
  {
    value: 91,
    label: 'Juventud Unida',
  },
  {
    value: 73,
    label: 'L. N. Alem',
  },
  {
    value: 2,
    label: 'Lanús',
    colors: {
      primary: '#85102A',
      secondary: '#DC7285',
    },
  },
  {
    value: 109,
    label: 'Libertad (Sunchales)',
  },
  {
    value: 92,
    label: 'Liniers',
  },
  {
    value: 32,
    label: 'Los Andes',
  },
  {
    value: 82,
    label: 'Lugano',
  },
  {
    value: 74,
    label: 'Luján',
  },
  {
    value: 88,
    label: 'Midland',
  },
  {
    value: 15,
    label: "Newell's",
    colors: {
      primary: '#000000',
      secondary: '#F42121',
    },
  },
  {
    value: 53,
    label: 'Nueva Chicago',
  },
  {
    value: 33,
    label: 'Olimpo',
    colors: {
      primary: '#213864',
      secondary: '#FFFFFF',
    },
  },
  {
    value: 110,
    label: 'Patronato',
    colors: {
      primary: '#BC0000',
      secondary: '#141414',
    },
  },
  {
    value: 34,
    label: 'Platense',
    colors: {
      primary: '#5C3919',
      secondary: '#FFFFFF',
    },
  },
  {
    value: 93,
    label: 'Puerto Nuevo',
  },
  {
    value: 35,
    label: 'Quilmes',
  },
  {
    value: 8,
    label: 'Racing',
    colors: {
      primary: '#0077A8',
      secondary: '#F4FCFF',
    },
  },
  {
    value: 23,
    label: 'Rafaela',
  },
  {
    value: 113,
    label: 'Real Arroyo Seco',
  },
  {
    value: 105,
    label: 'Rivadavia (Lincoln)',
  },
  {
    value: 12,
    label: 'River',
    colors: {
      primary: '#FF0000',
      secondary: '#FFFFFF',
    },
  },
  {
    value: 18,
    label: 'Rosario Ctral.',
    colors: {
      primary: '#FFCB05',
      secondary: '#0235B8',
    },
  },
  {
    value: 75,
    label: 'Sacachispas',
  },
  {
    value: 14,
    label: 'San Lorenzo',
    colors: {
      primary: '#00498D',
      secondary: '#DC310B',
    },
  },
  {
    value: 16,
    label: 'San Martín (Tuc.)',
  },
  {
    value: 94,
    label: 'San Martín de Burzaco',
  },
  {
    value: 36,
    label: 'San Martín SJ',
    colors: {
      primary: '#006931',
      secondary: '#000000',
    },
  },
  {
    value: 76,
    label: 'San Miguel',
  },
  {
    value: 54,
    label: 'San Telmo',
  },
  {
    value: 102,
    label: 'Santamarina (Tandil)',
  },
  {
    value: 55,
    label: 'Sarmiento',
    colors: {
      primary: '#008349',
      secondary: '#23E590',
    },
  },
  {
    value: 568,
    label: 'Sportivo Belgrano (Córdoba)',
  },
  {
    value: 56,
    label: 'Sportivo Italiano',
  },
  {
    value: 37,
    label: 'Talleres de Córdoba',
    colors: {
      primary: '#001C62',
      secondary: '#FFFFFF',
    },
  },
  // {
  //   value: 114,
  //   label: 'Talleres de Perico',
  // },
  // {
  //   value: 57,
  //   label: 'Talleres de Remedios de Escalada',
  // },
  {
    value: 58,
    label: 'Temperley',
    colors: {
      primary: '#00bdfc',
      secondary: '#ffffff',
    },
  },
  {
    value: 0,
    label: 'Tigre',
    colors: {
      primary: '#FE000F',
      secondary: '#134296',
    },
  },
  {
    value: 38,
    label: 'Tiro Federal',
  },
  {
    value: 59,
    label: 'Tristán Suárez',
  },
  {
    value: 108,
    label: 'Unión (Sunchales)',
  },
  {
    value: 39,
    label: 'Unión',
    colors: {
      primary: '#FF4E54',
      secondary: '#FFF5F5',
    },
  },
  {
    value: 6,
    label: 'Vélez',
    colors: {
      primary: '#FFFFFF',
      secondary: '#0334BD',
    },
  },
  {
    value: 96,
    label: 'Victoriano Arenas',
  },
  {
    value: 78,
    label: 'Villa Dálmine',
  },
  {
    value: 100,
    label: 'Villa Mitre (Bahía Blanca)',
  },
  {
    value: 79,
    label: 'Villa San Carlos',
  },
  {
    value: 97,
    label: 'Yupanqui',
  },
  {
    value: -1,
    label: 'Otro club',
  },
];

export const TEAM_LIST = [...RAW_TEAM_LIST].sort((a, b) =>
  a.label.localeCompare(b.label, 'es', { sensitivity: 'base' })
);

export const OPTIONS_PROVINCES = [
  { value: 1, label: 'Buenos Aires' },
  { value: 24, label: 'Ciudad Autónoma de Buenos Aires' },
  { value: 2, label: 'Catamarca' },
  { value: 3, label: 'Chaco' },
  { value: 4, label: 'Chubut' },
  { value: 5, label: 'Córdoba' },
  { value: 6, label: 'Corrientes' },
  { value: 7, label: 'Entre Ríos' },
  { value: 17, label: 'Formosa' },
  { value: 8, label: 'Jujuy' },
  { value: 9, label: 'La Pampa' },
  { value: 10, label: 'La Rioja' },
  { value: 11, label: 'Mendoza' },
  { value: 12, label: 'Misiones' },
  { value: 13, label: 'Neuquén' },
  { value: 14, label: 'Río Negro' },
  { value: 15, label: 'Salta' },
  { value: 16, label: 'San Juan' },
  { value: 18, label: 'San Luis' },
  { value: 23, label: 'Santa Cruz' },
  { value: 19, label: 'Santa Fe' },
  { value: 20, label: 'Santiago del Estero' },
  { value: 21, label: 'Tierra del Fuego' },
  { value: 22, label: 'Tucumán' },
];

// Referencia de Tácticas (nombre -> id) :
// - F_442 -> 1
// - F_433 -> 2
// - F_343 -> 3
// - F_451 -> 4
// - F_352 -> 5
// - F_532 -> 6
// - F_334 -> 7
// - F_424 -> 8
// - F_523 -> 9
export const TACTICS_ARR: number[][] = [
  [-1],
  [4, 4, 2],
  [4, 3, 3],
  [3, 4, 3],
  [4, 5, 1],
  [3, 5, 2],
  [5, 3, 2],
  [3, 3, 4],
  [4, 2, 4],
  [5, 2, 3],
];

export const POSITIONS_LABELS = {
  spanish: {
    arqueros: 'arqueros',
    defensores: 'defensores',
    volantes: 'volantes',
    delanteros: 'delanteros',
  },
  spanish_singular: {
    arquero: 'arquero',
    defensor: 'defensor',
    volante: 'volante',
    delantero: 'delantero',
  },
  english: {
    goalkeepers: 'goalkeepers',
    defenders: 'defenders',
    midfielders: 'midfielders',
    forwards: 'forwards',
  },
  abbreviation: {
    ARQ: 'ARQ',
    DEF: 'DEF',
    VOL: 'VOL',
    DEL: 'DEL',
  },
  all_field_players: 'ALL_FIELD_PLAYERS',
} as const;

export const POSITIONS_ARRAY = [
  POSITIONS_LABELS.abbreviation.ARQ,
  POSITIONS_LABELS.abbreviation.DEF,
  POSITIONS_LABELS.abbreviation.VOL,
  POSITIONS_LABELS.abbreviation.DEL,
];

export const PLAYER_POSITION_BY_ID = {
  1: POSITIONS_LABELS.abbreviation.ARQ,
  2: POSITIONS_LABELS.abbreviation.DEF,
  3: POSITIONS_LABELS.abbreviation.VOL,
  4: POSITIONS_LABELS.abbreviation.DEL,
} as const;

export const PLAYER_NAME_POSITION_BY_ID = {
  1: POSITIONS_LABELS.spanish.arqueros,
  2: POSITIONS_LABELS.spanish.defensores,
  3: POSITIONS_LABELS.spanish.volantes,
  4: POSITIONS_LABELS.spanish.delanteros,
} as const;

export const PLAYER_NAME_SINGULAR_POSITION_BY_ID = {
  1: POSITIONS_LABELS.spanish_singular.arquero,
  2: POSITIONS_LABELS.spanish_singular.defensor,
  3: POSITIONS_LABELS.spanish_singular.volante,
  4: POSITIONS_LABELS.spanish_singular.delantero,
} as const;

export const PLAYER_NAME_SINGULAR_POSITION_BY_ABBREVIATION = {
  [POSITIONS_LABELS.abbreviation.ARQ]:
    POSITIONS_LABELS.spanish_singular.arquero,
  [POSITIONS_LABELS.abbreviation.DEF]:
    POSITIONS_LABELS.spanish_singular.defensor,
  [POSITIONS_LABELS.abbreviation.VOL]:
    POSITIONS_LABELS.spanish_singular.volante,
  [POSITIONS_LABELS.abbreviation.DEL]:
    POSITIONS_LABELS.spanish_singular.delantero,
} as const;

export const PLAYER_POSITION_LABEL_BY_ABBREVIATION = {
  [POSITIONS_LABELS.abbreviation.ARQ]: POSITIONS_LABELS.spanish.arqueros,
  [POSITIONS_LABELS.abbreviation.DEF]: POSITIONS_LABELS.spanish.defensores,
  [POSITIONS_LABELS.abbreviation.VOL]: POSITIONS_LABELS.spanish.volantes,
  [POSITIONS_LABELS.abbreviation.DEL]: POSITIONS_LABELS.spanish.delanteros,
} as const;

export const PLAYER_FIELD_POSITION_BY_ABBREVIATION = {
  [POSITIONS_LABELS.abbreviation.ARQ]: POSITIONS_LABELS.english.goalkeepers,
  [POSITIONS_LABELS.abbreviation.DEF]: POSITIONS_LABELS.english.defenders,
  [POSITIONS_LABELS.abbreviation.VOL]: POSITIONS_LABELS.english.midfielders,
  [POSITIONS_LABELS.abbreviation.DEL]: POSITIONS_LABELS.english.forwards,
} as const;

export const PLAYER_FIELD_ABBREVIATION_BY_POSITION = {
  [POSITIONS_LABELS.english.goalkeepers]: POSITIONS_LABELS.abbreviation.ARQ,
  [POSITIONS_LABELS.english.defenders]: POSITIONS_LABELS.abbreviation.DEF,
  [POSITIONS_LABELS.english.midfielders]: POSITIONS_LABELS.abbreviation.VOL,
  [POSITIONS_LABELS.english.forwards]: POSITIONS_LABELS.abbreviation.DEL,
} as const;

export const PLAYER_ENGLISH_LABEL_BY_ID = {
  1: POSITIONS_LABELS.english.goalkeepers,
  2: POSITIONS_LABELS.english.defenders,
  3: POSITIONS_LABELS.english.midfielders,
  4: POSITIONS_LABELS.english.forwards,
} as const;

// Esta constante es para obtener el indice de los suplentes
// en el array de suplentes
export const SUBTITUTES_ID_KEYS_BY_ABBREVIATION = {
  [POSITIONS_LABELS.abbreviation.ARQ]: 0,
  [POSITIONS_LABELS.abbreviation.DEF]: 1,
  [POSITIONS_LABELS.abbreviation.VOL]: 2,
  [POSITIONS_LABELS.abbreviation.DEL]: 3,
} as const;

export const PLAYERSFIELD_ID_KEYS_BY_ABBREVIATION = {
  [POSITIONS_LABELS.abbreviation.DEF]: 2,
  [POSITIONS_LABELS.abbreviation.VOL]: 3,
  [POSITIONS_LABELS.abbreviation.DEL]: 4,
} as const;

export const PACKS_BY_NAME = {
  PREMIUM: 'PREMIUM',
  PREMIUM_1: 'PREMIUM_1',
  PACK_35: 'PACK_35',
  PACK_20: 'PACK_20',
  PACK_12: 'PACK_12',
  PACK_1: 'PACK_1',
  PRINTED_TICKETS: 'PRINTED_TICKETS',
  PIN_ESPECIAL_TDA_1: 'PIN_ESPECIAL_TDA_1',
  PIN_ESPECIAL_TDA_2: 'PIN_ESPECIAL_TDA_2',
  PIN_ESPECIAL_TDA_3: 'PIN_ESPECIAL_TDA_3',
  PIN_FECHA_ORO: 'PIN_FECHA_ORO',
  PIN_EDICION_PASADA: 'PIN_EDICION_PASADA',
};

export const MANUAL_PIN_LOAD_ID = 37;
export const PACKS_BY_ID = {
  [PACKS_BY_NAME.PREMIUM]: 19,
  [PACKS_BY_NAME.PREMIUM_1]: 20,
  [PACKS_BY_NAME.PACK_35]: 25,
  [PACKS_BY_NAME.PACK_20]: 5,
  [PACKS_BY_NAME.PACK_12]: 3,
  [PACKS_BY_NAME.PACK_1]: 1,
  [PACKS_BY_NAME.PRINTED_TICKETS]: 2,
  [PACKS_BY_NAME.PIN_ESPECIAL_TDA_1]: 30,
  [PACKS_BY_NAME.PIN_ESPECIAL_TDA_2]: 31,
  [PACKS_BY_NAME.PIN_ESPECIAL_TDA_3]: 32,
  [PACKS_BY_NAME.PIN_FECHA_ORO]: 33,
  [PACKS_BY_NAME.PIN_EDICION_PASADA]: 10,
};

export const PAYMENT_METHODS = {
  DEB_CRED: { id: 1, name: 'Débito/Crédito' },
  PAGO_MIS_CUENTAS: { id: 2, name: 'Pago Mis Cuentas' },
  LINK_PAGOS: { id: 3, name: 'Link Pagos' },
  PAGO_FACIL: { id: 4, name: 'Pago Fácil' },
} as const;

export type PaymentMethodKey = keyof typeof PAYMENT_METHODS;
export type PaymentMethod = (typeof PAYMENT_METHODS)[PaymentMethodKey];

export const PAYMENT_METHODS_BY_ID: Record<number, PaymentMethod> =
  Object.values(PAYMENT_METHODS).reduce(
    (acc, method) => ({ ...acc, [method.id]: method }),
    {}
  );

export const COLORS = {
  blue: {
    500: '#3366FF',
  },
  'gdt-blue': {
    dark: '#1B276A',
    header: '#2855C6',
    DEFAULT: '#3366FF',
    light: '#3399FE',
    light2: '#e4ebff',
    xl: '#00CEFF',
    xl2: '#E3EAFF',
    xl3: '#F1F5FF',
  },
  'gdt-status': {
    red: {
      DEFAULT: '#D84638',
      light: '#FFEDED',
    },
    orange: {
      DEFAULT: '#FF7A00',
      light: '#FFECDA',
    },
    yellow: {
      DEFAULT: '#BA9C06',
      light: '#FEF6BD',
      icon: '#EED551',
    },
    green: {
      DEFAULT: '#267F5F',
      light: '#D4F5EE',
      icon: '#00CC66',
    },
  },
  'gdt-gray': {
    DEFAULT: '#333333',
    2: '#4F4F4F',
    3: '#717077',
    4: '#A09EB3',
    5: '#D2D6D6',
    6: '#F2F2F2',
    7: '#F8F8F8',
    8: '#FFFFFF',
    9: '#3333334D',
  },
} as const;

export const THUMBS: ImageCover[] = [
  { id: 1, src: '/assets/images/bg_thumb-1.jpg' },
  { id: 2, src: '/assets/images/bg_thumb-2.jpg' },
  { id: 3, src: '/assets/images/bg_thumb-3.jpg' },
  { id: 4, src: '/assets/images/bg_thumb-4.jpg' },
  { id: 5, src: '/assets/images/bg_thumb-5.jpg' },
  { id: 6, src: '/assets/images/bg_thumb-6.jpg' },
  { id: 7, src: '', color: COLORS['gdt-blue'].header },
  { id: 8, src: '', color: COLORS['gdt-blue'].DEFAULT },
  { id: 9, src: '', color: COLORS['gdt-blue'].light },
];

export const COVER: ImageCover[] = [
  { id: 1, src: '/assets/images/bg_cover-1.jpg' },
  { id: 2, src: '/assets/images/bg_cover-2.jpg' },
  { id: 3, src: '/assets/images/bg_cover-3.jpg' },
  { id: 4, src: '/assets/images/bg_cover-4.jpg' },
  { id: 5, src: '/assets/images/bg_cover-5.jpg' },
  { id: 6, src: '/assets/images/bg_cover-6.jpg' },
  { id: 7, src: '', color: COLORS['gdt-blue'].header },
  { id: 8, src: '', color: COLORS['gdt-blue'].DEFAULT },
  { id: 9, src: '', color: COLORS['gdt-blue'].light },
];

const STATUS_ALERTS_COLORS = {
  red: {
    bgColor: COLORS['gdt-status'].red.light,
    textColor: COLORS['gdt-status'].red.DEFAULT,
  },
  orange: {
    bgColor: COLORS['gdt-status'].orange.light,
    textColor: COLORS['gdt-status'].orange.DEFAULT,
  },
  green: {
    bgColor: COLORS['gdt-status'].green.light,
    textColor: COLORS['gdt-status'].green.DEFAULT,
  },
  yellow: {
    bgColor: COLORS['gdt-status'].yellow.light,
    textColor: COLORS['gdt-status'].yellow.DEFAULT,
  },
  default: {
    bgColor: '#000000',
    textColor: '#FFFFFF',
  },
} as const;

export const PLAYER_STATUS_COLORS = {
  106: STATUS_ALERTS_COLORS.red,
  2: STATUS_ALERTS_COLORS.red,
  3: STATUS_ALERTS_COLORS.red,
  102: STATUS_ALERTS_COLORS.red,
  103: STATUS_ALERTS_COLORS.orange,
  104: STATUS_ALERTS_COLORS.green,
  105: STATUS_ALERTS_COLORS.yellow,
  107: STATUS_ALERTS_COLORS.yellow,
  200: STATUS_ALERTS_COLORS.yellow,
  201: STATUS_ALERTS_COLORS.default,
} as const;

export const PLAYER_STATUS_COLORS_ID_BY_NAME = {
  RED: 2,
  ORANGE: 103,
  GREEN: 104,
  YELLOW: 105,
  DEFAULT: 201,
} as const;

export const ERROR_STATUS_TDA = {
  PENDING_INVITATION: 330,
  PLAYING_TOURNEY: 307,
  DEFAULT_ERROR: 308,
} as const;

export const FIELD_ASSISTANT = {
  FIXTURE: 1,
  POSITIONS: 2,
  OUT: 3,
  INVICTUS: 4,
  GOL: 5,
  EX: 6,
  SCORE: 7,
  MY_PLAYERS: 8,
  TARJETOMETRO: 9,
  BUENOS_Y_BARATOS: 10,
  BEST_OF_MATCHDAY: 11,
  TOP_PLAYERS: 12,
  IDEAL_TEAM: 13,
  REPLACEMENTS: 14,
} as const;

// se dejan comentados las opciones que van a salir a prod en una segunda etapa
export const OPTIONS_ASSISTANT: SelectValue[] = [
  { value: 1, label: 'Fixture', disabled: false },
  { value: 2, label: 'Posiciones', disabled: false },
  { value: 3, label: 'Se quedan afuera', disabled: false },
  // { value: 4, label: 'Tarjetómetro', disabled: false },
  { value: 4, label: 'Valla invicta por club', disabled: false },
  { value: 12, label: 'Jugadores figura', disabled: false },
  // { value: 7, label: 'Reemplezados de la fecha', disabled: false },
  { value: 14, label: 'Los reemplazos de la fecha', disabled: false },
  { value: 11, label: 'Mejores de la fecha', disabled: false },
  { value: 13, label: 'Equipo ideal última fecha', disabled: false },
  { value: 5, label: 'Goleadores', disabled: false },
  { value: 6, label: 'Ley del Ex', disabled: false },
  { value: 10, label: 'Buenos y Baratos', disabled: false },
  // { value: 12, label: 'Equipo ideal última fecha', disabled: false },
  { value: 7, label: 'Puntajes de la última fecha', disabled: false },
  { value: 8, label: 'Puntajes de mis jugadores', disabled: false },
  { value: 9, label: 'Tarjetómetro', disabled: false },
  // { value: 15, label: 'Mis futbolistas favoritos', disabled: false },
];

export const ERROR_STATUS_FCUP = {
  PENDING_INVITATION: 2623,
} as const;

// Define the status types as a const enum or const object
export const STATUS_TOURNEY_INVITATION = {
  PENDING: 'PENDIENTE' as const,
  REJECTED: 'RECHAZADO' as const,
} as const;

export const STATUS_ID_INVITATION = {
  PENDIENTE_ACEPTAR_DUENIO: 1,
  PARTICIPANDO: 2,
  ELIMINADO: 3,
  RECHAZADO: 4,
  PENDIENTE_ACEPTAR_INVITADO: 5,
  RECHAZA_INVITADO: 6,
} as const;

export const STATUS_INVITATION_FCUP = {
  PENDIENTE_ACEPTAR_DUENIO: 'PENDIENTE_ACEPTAR_DUENIO',
  PARTICIPANDO: 'PARTICIPANDO',
  ELIMINADO: 'ELIMINADO',
  RECHAZADO: 'RECHAZADO',
  PENDIENTE_ACEPTAR_INVITADO: 'PENDIENTE_ACEPTAR_INVITADO',
  RECHAZA_INVITADO: 'RECHAZA_INVITADO',
} as const;
// get criterio de posicion de jugador por id
export const CRITERIA_RECOMMENDER = {
  [POSITIONS_LABELS.abbreviation.ARQ]: [
    { 1: 'Más goleadores' },
    { 2: 'Con menos goles recibidos' },
    { 3: 'Más veces figura' },
    { 4: 'Con más penales atajados' },
  ],
  [POSITIONS_LABELS.abbreviation.DEF]: [
    { 5: 'Más goleadores' },
    { 6: 'Con menos goles recibidos' },
    { 7: 'Con menos tarjetas recibidas' },
    { 8: 'Más elegidos' },
  ],
  [POSITIONS_LABELS.abbreviation.VOL]: [
    { 9: 'Más goleadores' },
    { 10: 'Con más minutos de juego' },
    { 11: 'Más veces figura' },
    { 12: 'Más elegidos' },
  ],
  [POSITIONS_LABELS.abbreviation.DEL]: [
    { 13: 'Más goleadores' },
    { 14: 'Más goleadores de visitante' },
    { 15: 'Con más penales convertidos' },
    { 16: 'Más veces figura' },
  ],
};

// VISUAL EFFECT LAYOUT
export const FADE_IN_OUT_LEFT = {
  show: {
    opacity: 1,
    x: 0,
    transition: {
      ease: 'easeInOut',
      duration: 0,
    },
  },
  hide: {
    x: 20,
    opacity: 0,
  },
};

export const FADE_IN_OUT = {
  show: {
    opacity: 1,
    transition: {
      ease: 'easeInOut',
      duration: 0,
    },
  },
  hide: {
    opacity: 0,
    transition: {
      ease: 'easeInOut',
      duration: 0,
    },
  },
};

export const fadeInOut = (time: number) => {
  return {
    show: {
      opacity: 1,
      transition: {
        ease: 'easeInOut',
        duration: time,
      },
    },
    hide: {
      opacity: 0,
      transition: {
        ease: 'easeInOut',
        duration: time,
      },
    },
  };
};

export const SLIDE_IN_OUT_LEFT = {
  show: {
    x: 0,
    opacity: 1,
    transition: {
      ease: 'easeInOut',
      duration: 0,
    },
  },
  hide: {
    x: '100%',
    opacity: 0,
    transition: {
      ease: 'easeInOut',
      duration: 0,
    },
  },
};

export const CODES_ERRORS = {
  MY_TEAM11: {
    INVALID_TRANSFER: 217,
  },
} as const;

export const EMPTY_TEMPLATE_PLAYER = {
  id: 0,
  a: '',
  n: '',
  c: 0,
  p: 0,
  cot: 0,
  e: 0,
  o: 0,
  pt: 0,
  pj: 0,
  pm: '',
  dts: 0,
  dtsF5: 0,
  fig: 0,
  gol: 0,
  golPen: 0,
  valla: 0,
  penAtaj: 0,
  roj: 0,
  ama: 0,
  eliminado: false,
};

export const BACKGROUND_CLASS_SECTION_APP = {
  default: 'default',
  register: 'bg-register',
  school: 'bg-school',
  nameTeam: 'bg-nameteam',
  welcome_1: 'bg-welcome_1',
  welcome_2: 'bg-welcome_2',
  welcomeF5_1: 'bg-welcomeF5_1',
  welcomeF5_2: 'bg-welcomeF5_2',
};

export const hashNameComponents = {
  showPlayersListTransfer: '#showPlayersListTransfer',
};

export const resetStatePostTransfer = {
  type: TeamActionTypes.SET_STATE,
  payload: {
    playerDetailsModalOpen: false,
    showPlayersListTransfer: false,
  },
};

export const TRANSFER_BALANCE_REASONS: SelectValue[] = [
  { label: '...Seleccionar', value: 0, disabled: true },
  { label: 'Apuesta perdida', value: 1 },
  { label: 'Regalo', value: 2 },
  { label: 'Otro..', value: 3 },
];

type CardConfig = {
  id: number;
  key: string;
  nombre: string;
  img: string;
  debito: boolean;
  disabled?: boolean;
};

export const CONF_TARJETAS = {
  CREDITO: {
    id: 1,
    key: 'credito',
    nombre: 'Visa Crédito',
    debito: false,
    img: 'visa_logo.png',
  },
  DEBITO: {
    id: 5,
    key: 'debito',
    nombre: 'Visa Débito',
    debito: true,
    img: 'visa_logo.png',
  },
  MASTER: {
    id: 2,
    key: 'mc',
    nombre: 'Mastercard',
    debito: false,
    img: 'mastercard_logo.png',
  },
  MAESTRO: {
    id: 4,
    key: 'maestro',
    nombre: 'Maestro',
    debito: true,
    img: 'maestro_logo.png',
  },
  AMEX: {
    id: 3,
    key: 'amex',
    debito: false,
    nombre: 'American Express',
    img: 'amex_logo.jpg',
  },

  // CABAL: { id: 6, key: 'cabal', nombre: 'CABAL', disabled: true },
  // NARANJA: { id: 7, key: 'naranja', nombre: 'NARANJA', disabled: true },
} as const satisfies Record<string, CardConfig>;

export type CardKey = keyof typeof CONF_TARJETAS;

export const CARD_MAPPER: Record<
  CardKey,
  TarjetaTokenizada['codigoMedioPagoGdt']
> = {
  CREDITO: 'credito',
  DEBITO: 'debito',
  MASTER: 'mc',
  MAESTRO: 'maestro',
  AMEX: 'amex',
};

export const GENERICS_AMOUNTS = {
  MAX_PLAYERS_FCUP: 4,
};

export const GENERICS_WORDS = {
  f5: 'Fútbol 5',
  f11: 'Primera División',
  date: 'Fecha',
  gral: 'Torneo General',
  tdaClassic: 'Torneos Clásicos',
  tdaPremio: 'Torneos por Premios',
  tourneys: 'Torneos',
  teams: 'Equipos',
  friendsCup: 'Copa de Amigos',
  coachs: "DT's",
  participant: 'participante',
  participants: 'participantes',
  minileagues: 'Miniligas',
  fixture: 'Fixture',
  positions: 'Posiciones',
  goldDate: 'Fecha de Oro',
  challenges: 'Desafíos',
  results: 'Resultados',
  desafios: 'Desafíos',
  resultados: 'Resultados',
};

export const ABCD = ['A', 'B', 'C', 'D'];

export const EnumModalWinner = {
  FUTBOL5: {
    id: 1,
    tituloBarra: 'FÚTBOL 5',
    titulo: 'Fuiste ganador de una fecha de Fútbol 5.',
    // subtitulo:
    //   'Necesitamos que nos compartas acá tus datos para que puedas recibir tu premio.',
    // clsSubtitulo: '',
  },
  FUTBOL5_GRAL: {
    id: 2,
    tituloBarra: 'FÚTBOL 5',
    titulo:
      'Fuiste el campeón, recibirás tu premio por transferencia bancaria.',
    // subtitulo:
    //   'Necesitamos que nos compartas acá tus datos para que puedas recibir tu premio.',
    // clsSubtitulo: '',
  },
  FECHA_PREMIUM: {
    id: 4,
    tituloBarra: 'FECHA PREMIUM',
    titulo: 'Fuiste uno de los ganadores de la Fecha Premium. ',
    // subtitulo:
    //   'Necesitamos que nos compartas acá tus datos para que puedas recibir tu premio.',
    // clsSubtitulo: '',
  },
  TDA_PREMIUM: {
    id: 5,
    tituloBarra: 'TORNEO PREMIUM',
    titulo: 'Fuiste uno de los ganadores.',
    // subtitulo:
    //   'Necesitamos que nos compartas acá tus datos para que puedas recibir tu premio.',
    // clsSubtitulo: '',
  },
};

export const MATCH_STATUS = {
  VERIFICADO: 2,
  SUSPENDIDO: 3,
} as const;

// extrae el id de usuario de una url del tipo perfil-52/fp-17444752-mini.jpg
export const getPhotoUserId = (url?: string) =>
  url?.match(/fp-(\d+)-mini/)?.[1];
